import { tss } from "tss-react/mui";

export const useNewsletterSectionStyles = tss.withName("NewsletterSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[900],
        color: theme.palette.common.white,
    },
    inner: {
        textAlign: "center" as const,
        maxWidth: 560,
        margin: "0 auto",
    },
    title: {
        color: theme.palette.common.white,
        marginBottom: theme.spacing(1.5),
    },
    description: {
        color: "rgba(255,255,255,0.75)",
        marginBottom: theme.spacing(4),
        lineHeight: 1.8,
    },
    form: {
        display: "flex",
        gap: theme.spacing(1.5),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column" as const,
        },
    },
    input: {
        flex: 1,
        "& .MuiOutlinedInput-root": {
            backgroundColor: "rgba(255,255,255,0.08)",
            borderRadius: "4px",
            color: theme.palette.common.white,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.25)",
        },
    },
    disclaimer: {
        marginTop: theme.spacing(2),
        color: "rgba(255,255,255,0.5)",
        fontSize: "0.75rem",
    },
}));
